'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var medicalInformation = {
    DIETARY_RESTRICTIONS: (0, _reactIntl.defineMessages)({
        NO_DIETARY_REQUIREMENTS: {
            'id': 'formOverrides.medicalInformation.NO_DIETARY_REQUIREMENTS',
            'defaultMessage': 'I do NOT have any APPLICABLE allergies or dietary restrictions.'
        }
    }),
    MEDICAL_CONDITIONS: (0, _reactIntl.defineMessages)({
        NO_PREVIOUS_MED_CONDITIONS: {
            'id': 'formOverrides.medicalInformation.MEDICAL_CONDITIONS.NO_PREVIOUS_MED_CONDITIONS',
            'defaultMessage': 'I do NOT have any APPLICABLE pre-existing medical conditions.'
        }
    }),
    RISK_TO_OTHERS: (0, _reactIntl.defineMessages)({
        NO_PREVIOUS_MED_CONDITIONS: {
            'id': 'formOverrides.medicalInformation.RISK_TO_OTHERS.NO_PREVIOUS_MED_CONDITIONS',
            'defaultMessage': 'I do not have any medical conditions which may pose a risk to others.'
        }
    }),
    MOBILITY_ISSUES: (0, _reactIntl.defineMessages)({
        NO_PREVIOUS_MED_CONDITIONS: {
            'id': 'formOverrides.medicalInformation.MOBILITY_ISSUES.NO_PREVIOUS_MED_CONDITIONS',
            'defaultMessage': 'I do NOT have any APPLICABLE mobility issues.'
        }
    })
};

exports.default = medicalInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/medicalInformation.js
// module id = 1384
// module chunks = 0